import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Send = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M5.69214 10.9908C5.18321 10.8636 4.86513 10.3551 5.05598 9.84655C5.1196 9.52871 5.37406 9.33801 5.69214 9.21087L18.479 5.07899C18.6699 4.88829 18.9243 5.07899 19.0516 5.26969C19.0516 5.33326 19.0516 5.4604 19.0516 5.58753L14.9165 18.3646C14.7256 18.8731 14.2167 19.1274 13.7078 18.9367C13.3897 18.8096 13.1989 18.6188 13.0716 18.301L11.6721 12.3892L5.69214 10.9908Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9243 5.07886L11.6084 12.3891"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
